var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "template-designer" },
    [
      _c("div", { staticClass: "designer-toolbar" }, [
        _c(
          "div",
          { staticClass: "toolbar-left" },
          [
            _c(
              "a-button",
              { attrs: { icon: "arrow-left" }, on: { click: _vm.goBack } },
              [_vm._v("返回列表")]
            ),
            _c("a-divider", { attrs: { type: "vertical" } }),
            _c(
              "a-button",
              {
                attrs: { size: "small", icon: "undo" },
                on: { click: _vm.handleReset },
              },
              [_vm._v("恢复默认模板")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "toolbar-center" },
          [
            _c(
              "a-radio-group",
              {
                attrs: { size: "small" },
                on: { change: _vm.onPaperSizeChange },
                model: {
                  value: _vm.paperSize,
                  callback: function ($$v) {
                    _vm.paperSize = $$v
                  },
                  expression: "paperSize",
                },
              },
              [
                _c("a-radio-button", { attrs: { value: "A4" } }, [
                  _vm._v("A4"),
                ]),
                _c("a-radio-button", { attrs: { value: "A5" } }, [
                  _vm._v("A5"),
                ]),
                _c("a-radio-button", { attrs: { value: "B5" } }, [
                  _vm._v("B5"),
                ]),
                _c("a-radio-button", { attrs: { value: "custom" } }, [
                  _vm._v("自定义"),
                ]),
              ],
              1
            ),
            _vm.paperSize === "custom"
              ? [
                  _c("a-input-number", {
                    staticStyle: { width: "80px" },
                    attrs: { min: 50, max: 500, step: 5, size: "small" },
                    model: {
                      value: _vm.paperWidth,
                      callback: function ($$v) {
                        _vm.paperWidth = $$v
                      },
                      expression: "paperWidth",
                    },
                  }),
                  _vm._v(" mm\n        "),
                  _c("span", { staticStyle: { margin: "0 6px" } }, [
                    _vm._v("×"),
                  ]),
                  _c("a-input-number", {
                    staticStyle: { width: "80px" },
                    attrs: { min: 50, max: 500, step: 5, size: "small" },
                    model: {
                      value: _vm.paperHeight,
                      callback: function ($$v) {
                        _vm.paperHeight = $$v
                      },
                      expression: "paperHeight",
                    },
                  }),
                  _vm._v(" mm\n      "),
                ]
              : _vm._e(),
            _c("a-divider", { attrs: { type: "vertical" } }),
            _c(
              "a-button",
              {
                attrs: { size: "small", icon: "zoom-in" },
                on: { click: _vm.zoomIn },
              },
              [_vm._v("+")]
            ),
            _c("a-input-number", {
              staticStyle: { width: "70px" },
              attrs: { size: "small", min: 25, max: 200, step: 25 },
              on: { change: _vm.onZoomChange },
              model: {
                value: _vm.zoomLevel,
                callback: function ($$v) {
                  _vm.zoomLevel = $$v
                },
                expression: "zoomLevel",
              },
            }),
            _c(
              "a-button",
              {
                attrs: { size: "small", icon: "zoom-out" },
                on: { click: _vm.zoomOut },
              },
              [_vm._v("-")]
            ),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "toolbar-right" },
          [
            _c("a-input", {
              staticStyle: { width: "150px", "margin-right": "10px" },
              attrs: { placeholder: "模板名称", size: "small" },
              model: {
                value: _vm.templateName,
                callback: function ($$v) {
                  _vm.templateName = $$v
                },
                expression: "templateName",
              },
            }),
            _c(
              "a-button",
              {
                attrs: { type: "primary", icon: "eye" },
                on: { click: _vm.handlePreview },
              },
              [_vm._v("打印预览")]
            ),
            _c(
              "a-button",
              { attrs: { icon: "reload" }, on: { click: _vm.handleRefresh } },
              [_vm._v("刷新")]
            ),
            _c("a-divider", { attrs: { type: "vertical" } }),
            _c(
              "a-button",
              {
                attrs: { type: "primary", icon: "save", loading: _vm.saving },
                on: { click: _vm.handleSave },
              },
              [_vm._v("保存")]
            ),
            _c(
              "a-button",
              {
                on: {
                  click: function ($event) {
                    _vm.showTemplateJsonModal = true
                  },
                },
              },
              [_vm._v("模板JSON")]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "designer-main" }, [
        _c(
          "div",
          { staticClass: "fields-panel" },
          [
            _c(
              "a-collapse",
              {
                attrs: { bordered: false, expandIconPosition: "left" },
                model: {
                  value: _vm.activeKeys,
                  callback: function ($$v) {
                    _vm.activeKeys = $$v
                  },
                  expression: "activeKeys",
                },
              },
              _vm._l(_vm.fieldGroups, function (group) {
                return _c(
                  "a-collapse-panel",
                  { key: group.key, attrs: { header: group.title } },
                  [
                    _c(
                      "div",
                      { staticClass: "field-group" },
                      _vm._l(group.fields, function (field) {
                        return _c(
                          "div",
                          {
                            key: field.key,
                            staticClass: "field-item",
                            class: { "field-group-title": field.isGroup },
                            attrs: { draggable: !field.isGroup },
                            on: {
                              click: function ($event) {
                                return _vm.addFieldToCanvas(field)
                              },
                              dragstart: function ($event) {
                                return _vm.onFieldDragStart($event, field)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(field.label) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "designer-container" }, [
          _c("div", {
            ref: "designerContainer",
            staticClass: "designer-canvas",
            on: {
              drop: function ($event) {
                $event.preventDefault()
                return _vm.onDrop($event)
              },
              dragover: function ($event) {
                $event.preventDefault()
              },
            },
          }),
        ]),
        _vm.selectedElement
          ? _c("div", { staticClass: "property-panel" }, [
              _c(
                "div",
                { staticClass: "property-header" },
                [
                  _c("span", [_vm._v("属性设置")]),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link", size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.selectedElement = null
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "property-content" },
                [
                  _c(
                    "a-form",
                    { attrs: { layout: "vertical", size: "small" } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "标题" } },
                        [
                          _c("a-input", {
                            on: { change: _vm.updateElement },
                            model: {
                              value: _vm.selectedElement.options.title,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectedElement.options,
                                  "title",
                                  $$v
                                )
                              },
                              expression: "selectedElement.options.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "字段" } },
                        [
                          _c("a-input", {
                            on: { change: _vm.updateElement },
                            model: {
                              value: _vm.selectedElement.options.field,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectedElement.options,
                                  "field",
                                  $$v
                                )
                              },
                              expression: "selectedElement.options.field",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "宽度" } },
                        [
                          _c("a-input-number", {
                            attrs: { min: 10, max: 500 },
                            on: { change: _vm.updateElement },
                            model: {
                              value: _vm.selectedElement.options.width,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectedElement.options,
                                  "width",
                                  $$v
                                )
                              },
                              expression: "selectedElement.options.width",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "高度" } },
                        [
                          _c("a-input-number", {
                            attrs: { min: 5, max: 500 },
                            on: { change: _vm.updateElement },
                            model: {
                              value: _vm.selectedElement.options.height,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectedElement.options,
                                  "height",
                                  $$v
                                )
                              },
                              expression: "selectedElement.options.height",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "左边距" } },
                        [
                          _c("a-input-number", {
                            attrs: { min: 0, max: 500 },
                            on: { change: _vm.updateElement },
                            model: {
                              value: _vm.selectedElement.options.left,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectedElement.options,
                                  "left",
                                  $$v
                                )
                              },
                              expression: "selectedElement.options.left",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "上边距" } },
                        [
                          _c("a-input-number", {
                            attrs: { min: 0, max: 500 },
                            on: { change: _vm.updateElement },
                            model: {
                              value: _vm.selectedElement.options.top,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectedElement.options,
                                  "top",
                                  $$v
                                )
                              },
                              expression: "selectedElement.options.top",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "字体大小" } },
                        [
                          _c("a-input-number", {
                            attrs: { min: 8, max: 72 },
                            on: { change: _vm.updateElement },
                            model: {
                              value: _vm.selectedElement.options.fontSize,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectedElement.options,
                                  "fontSize",
                                  $$v
                                )
                              },
                              expression: "selectedElement.options.fontSize",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "对齐方式" } },
                        [
                          _c(
                            "a-select",
                            {
                              on: { change: _vm.updateElement },
                              model: {
                                value: _vm.selectedElement.options.textAlign,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.selectedElement.options,
                                    "textAlign",
                                    $$v
                                  )
                                },
                                expression: "selectedElement.options.textAlign",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "left" } },
                                [_vm._v("左对齐")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "center" } },
                                [_vm._v("居中")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "right" } },
                                [_vm._v("右对齐")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "粗体" } },
                        [
                          _c("a-switch", {
                            attrs: {
                              "checked-children": "粗",
                              "un-checked-children": "细",
                            },
                            on: { change: _vm.updateElement },
                            model: {
                              value: _vm.selectedElement.options.fontWeight,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectedElement.options,
                                  "fontWeight",
                                  $$v
                                )
                              },
                              expression: "selectedElement.options.fontWeight",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "隐藏标题" } },
                        [
                          _c("a-switch", {
                            on: { change: _vm.updateElement },
                            model: {
                              value: _vm.selectedElement.options.hideTitle,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectedElement.options,
                                  "hideTitle",
                                  $$v
                                )
                              },
                              expression: "selectedElement.options.hideTitle",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "danger",
                                size: "small",
                                block: "",
                              },
                              on: { click: _vm.deleteSelectedElement },
                            },
                            [_vm._v("删除元素")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "打印预览",
            width: 900,
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.previewVisible = false
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "preview-toolbar",
              staticStyle: { "margin-bottom": "16px" },
            },
            [
              _c(
                "a-button",
                {
                  attrs: { type: "primary", icon: "printer" },
                  on: { click: _vm.handlePrintPreview },
                },
                [_vm._v("打印")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { ref: "previewContent", staticClass: "preview-content" },
            [
              _c(
                "a-spin",
                { attrs: { spinning: _vm.previewLoading } },
                [
                  _vm.previewHtml
                    ? _c("div", {
                        staticClass: "preview-html",
                        domProps: { innerHTML: _vm._s(_vm.previewHtml) },
                      })
                    : _c("a-empty", { attrs: { description: "暂无预览内容" } }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.showTemplateJsonModal,
            title: "模板JSON",
            width: 800,
          },
          on: {
            ok: function ($event) {
              _vm.showTemplateJsonModal = false
            },
            cancel: function ($event) {
              _vm.showTemplateJsonModal = false
            },
          },
        },
        [
          _c("a-textarea", {
            attrs: { rows: 15, readOnly: "" },
            model: {
              value: _vm.templateJsonText,
              callback: function ($$v) {
                _vm.templateJsonText = $$v
              },
              expression: "templateJsonText",
            },
          }),
          _c(
            "div",
            { staticStyle: { "margin-top": "16px", "text-align": "right" } },
            [
              _c("a-button", { on: { click: _vm.copyTemplateJson } }, [
                _vm._v("复制"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }